import { render, staticRenderFns } from "./CarrinhoLista.vue?vue&type=template&id=1252d83e&scoped=true"
import script from "./CarrinhoLista.vue?vue&type=script&lang=js"
export * from "./CarrinhoLista.vue?vue&type=script&lang=js"
import style0 from "./CarrinhoLista.vue?vue&type=style&index=0&id=1252d83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252d83e",
  null
  
)

export default component.exports